import { manageTranslations as TranslationHelper } from '@morsedigital/i18n_helper';

const wp = TranslationHelper('javascript')('weekly_programme');

const hasKeyAndValue = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key) && obj[key];

export default item => {
  const noLink = { link: null, title: null, instruction: null, places: null, book_alert: null };
  const urlProtocol = /^http/;
  if (hasKeyAndValue(item, 'booking_instruction') && !(urlProtocol.test(item.booking_instruction))) {
    return {
      ...noLink,
      instruction: item.booking_instruction,
      places: item.places_left,
    };
  }

  if (hasKeyAndValue(item.buttons, 'buy')) {
    return {
      ...noLink,
      title: wp('additional.buy'),
      link: item.buttons.buy,
      places: item.places_left,
    };
  }

  if (hasKeyAndValue(item.buttons, 'book')) {
    return {
      ...noLink,
      title: wp('additional.book'),
      link: item.buttons.book,
      places: item.places_left,
      book_alert: item.buttons.book_alert,
    };
  }

  return noLink;
};
